export default "/images/8d783b7763574f4a853b6ea3b5abe41c.avif";